import { z } from 'zod';
/**
 * Call Update Variables v1 Configuration Validator
 * Validates configuration for updating call variables in pre-call workflows
 */
export const Call_Update_Variables_1_ConfigValidator = z.object({
    variables: z.record(z.string(), z.unknown())
});
//# sourceMappingURL=call-update-variables-1.js.map